import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  noAllocations: {
    description: 'Inventory allocations grid when there are no allocations made',
    defaultMessage: 'No allocations have been made for this product',
    id: 'tlQUlq',
  },
  allocatedOrdersHeader: {
    description: 'Section title for allocated orders in the product details tab inventory',
    defaultMessage: 'Allocated Orders',
    id: '+dGgBK',
  },
  allocationsDeallocationLink: {
    description: 'Inventory allocations grid de-allocation link',
    defaultMessage: 'Deallocate All',
    id: 'H2je7t',
  },
  deallocateButton: {
    description: 'Deallocate button label in V3 inventory tab',
    defaultMessage: 'Deallocate',
    id: '8oqGSM',
  },
  deallocateWarningModalCancel: {
    description: 'Deallocation warning modal cancel button',
    defaultMessage: 'Cancel',
    id: '9NELGA',
  },
  deallocateWarningModalConfirm: {
    description: 'Deallocation warning modal confirm button',
    defaultMessage: 'Confirm Deallocation',
    id: 'VPL+Gh',
  },
  deallocationWarningModalTitle: {
    description: 'Deallocation warning modal header',
    defaultMessage: 'Deallocate All Orders',
    id: 'PZ4Yf/',
  },
  deallocationWarningModalBody: {
    description: 'Deallocation warning modal warning message',
    defaultMessage:
      'Deallocating this product will deallocate {orderCount} order. The order will be completely deallocated including other products not currently selected.',
    id: 'LhoZ2V',
  },
  deallocationFailureTitle: {
    description: 'inventory.deallocationFailureTitle',
    defaultMessage: 'Failed To Deallocate',
    id: '1uNJXE',
  },
  deallocationFailureMessage: {
    description: 'inventory.deallocationFailureMessage',
    defaultMessage: 'An error occurred while attempting to deallocate',
    id: 'b46WWE',
  },
  deallocationSuccessTitle: {
    description: 'inventory.deallocationSuccessTitle',
    defaultMessage: 'Deallocation Successful',
    id: 'zi0nQ1',
  },
  deallocationSuccessMessage: {
    description: 'inventory.deallocationSuccessMessage',
    defaultMessage: 'Successfully deallocated',
    id: 'Ma0LqG',
  },
});
